<template>
    <component
        :is="embedded ? 'div' : 'el-dialog'"
        v-model="mainDialogVisible"
        class="ttl-system-photos-wrap-dialog"
        :class="{ 'is-embedded': embedded }"
        :title="embedded ? '' : currentDialogTitle"
        width="92%"
        top="4vh"
        append-to-body
        :close-on-click-modal="true"
        :show-close="!embedded"
        :modal="!embedded"
        @close="handleMainDialogClose"
    >
        <div
            class="TTL-system-photos-box"
            ref="systemPhotosDialogBox"
            v-loading="uploadDialogLoading"
            :element-loading-text="uploadDialogLoadingText"
        >

        <!-- 分类模块 -->
        <div class="TTL-cate-box">
            <span class="TTL-add-cate" @click="openAddCateDialog">+ 新增分类</span>
            <div class="TTL-cate-content">
                <div class="cate-box">
                    <div class="cate-item" v-for="(item, index) in categoryDisplayList" :key="item.id || `cate-${index}`">
                        <div class="cate-name-box" @click="handleCateSelect(item)">
                            <span
                                class="title"
                                :class="{ 'title-with-caret': item._level === 0 || item._hasChildren }"
                                :style="{
                                    paddingLeft: `${item._level * 25}px`,
                                    color: String(item.id) === String(searchForm.cateid) ? '#666eeb' : '#333'
                                }"
                            >
                                <span
                                    v-if="item._level === 0 || item._hasChildren"
                                    class="cate-title-caret-wrap"
                                    @click.stop="onCateCaretClick(item)"
                                >
                                    <i
                                        class="cate-title-caret"
                                        :class="{ 'is-collapsed': item._hasChildren && collapsedCateMap[String(item.id)] }"
                                        aria-hidden="true"
                                    />
                                </span>
                                <span class="cate-title-text">{{ item.name }}</span>
                            </span>
                            <div class="icon-box" :class="{ 'is-empty': !(item.id > 0) }">
                                <template v-if="item.id > 0">
                                    <div class="icon edit" @click.stop="openEditCateDialog(item)" />
                                    <div class="icon del" @click.stop="handleDeleteCate(item)" />
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 图集模块 -->
        <div class="TTL-photo-box">
            <div class="photo-header-box">
                <el-form inline="true">
                    <el-form-item>
                        <wcinput 
                            :value="searchForm.name" 
                            :option="{
                                placeholder: '请输入图片名称',
                                clearable: true,
                                width: '250px',
                                ischange: true,
                                iskeydown: true
                            }"
                            @finish="handleSearchNameChange"
                        />
                    </el-form-item>
                    <el-form-item>
                        <wcbutton 
                            :option="{
                                title: '搜索',
                                type: 'primary'
                            }"
                            @finish="handleSearch"
                        />
                    </el-form-item>
                    <el-form-item>
                        <wcbutton 
                            :option="{
                                title: '上传文件',
                                type: ''
                            }"
                            @finish="uploadimages"
                        />
                    </el-form-item>
                    <el-form-item v-if="selectable">
                        <el-badge :value="selectphotos.length > 0 ? selectphotos.length : ''" class="item">
                        <wcbutton 
                            :option="{
                                title: '确认选择',
                                type: ''
                            }"
                            @finish="handleConfirmSelection"
                        />
                        </el-badge>
                    </el-form-item>
                    <el-form-item v-if="selectable">
                        <wcbutton 
                            :option="{
                                title: '重置',
                                type: 'del'
                            }"
                            @finish="handleResetSelection"
                        />
                    </el-form-item>
                    <el-form-item v-if="selectable">
                        <span class="header-notice">注：点击图片即可选中/取消选中图片</span>
                    </el-form-item>
                </el-form>
            </div>
            <div class="photo-content-box">
                <div class="empty-data" v-if="photos.length===0">
                    <el-empty description="暂无数据" />
                </div>
                <template v-else>
                    <div
                        class="photo-items"
                        :class="{ 'photo-items-active': isPhotoSelected(item) }"
                        v-for="(item,index) in photos"
                        :key="item.id || index"
                        @click="toggleSelectPhoto(item)"
                    >
                        <!-- <div class="photo-check" v-if="isPhotoSelected(item)" /> -->
                        <div class="photo-check-sort" v-if="showSelectSort(item) > 0">{{showSelectSort(item)}}</div>
                        <div class="pic-box">
                            <el-image 
                                :src="item.url" 
                                fit="cover" 
                                class="pic"
                                lazy="true"
                            />
                        </div>
                        <div class="pic-name-box top10">
                            <el-tooltip :content="item.name || ''" placement="top" :show-after="200">
                                <span class="name">{{ item.name }}</span>
                            </el-tooltip>
                            <div class="pic-btn-box">
                                <span class="icon edit" @click.stop="openEditPhotoDialog(item)" />
                                <span class="icon del" @click.stop="handleDeletePhoto(item)" />
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div class="TTL-page-box top20" v-if="photos.length > 0">
                <div class="TTL-page-box-in">
                    <div class="TTL-page TTL-page-right">
                        <wcpage
                            :row="searchForm.rows"
                            :p="searchForm.page"
                            :rollpage="searchForm.rollpage"
                            @finish="(val) => {
                                // 分页组件返回当前页和每页条数，回填后重新拉取列表
                                searchForm.page = val.p;
                                searchForm.rollpage = val.rollpage;
                                searchForm.ischange = true;
                                getPhotoList();
                            }"
                        />
                    </div>
                </div>
            </div>
        </div>

        </div>
    </component>

        <!-- 新增分类弹窗 -->
        <el-dialog v-model="addCateDialogVisible" title="新增分类" width="420px" :close-on-click-modal="false" append-to-body>
            <div class="add-cate-form">
                <div class="form-item">
                    <div class="form-label">父级分类</div>
                    <div class="form-control">
                        <wccascader
                            :value="addCateForm.parentPath"
                            :list="categorycascade"
                            :option="{ placeholder: '请选择父级分类（可为空）', clearable: true, filterable: true, width: 250, props: { checkStrictly: true }, closeOnSelect: true }"
                            @finish="handleParentCascadeChange"
                        />
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">分类名称</div>
                    <div class="form-control">
                        <wcinput
                            :value="addCateForm.name"
                            :option="{ placeholder: '请输入分类名称', type: 'input', clearable: true, width: '250px', ischange: true }"
                            @finish="(val) => handleAddCateInputChange('name', val)"
                        />
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">排序</div>
                    <div class="form-control">
                        <wcinput
                            :value="addCateForm.sort"
                            :option="{ placeholder: '请输入排序值', type: 'input', clearable: true, width: '250px', ischange: true }"
                            @finish="(val) => handleAddCateInputChange('sort', val)"
                        />
                    </div>
                </div>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <wcbutton :option="{ title: '取消', type: 'del' }" @finish="closeAddCateDialog" />
                    <wcbutton :option="{ title: '提交', type: 'primary' }" @finish="submitAddCategory" />
                </div>
            </template>
        </el-dialog>

        <!-- 编辑分类名称弹窗 -->
        <el-dialog v-model="editCateDialogVisible" title="编辑分类" width="420px" :close-on-click-modal="false" append-to-body>
            <div class="add-cate-form">
                <div class="form-item">
                    <div class="form-label">父级分类</div>
                    <div class="form-control">
                        <wccascader
                            :value="editCateForm.parentPath"
                            :list="categorycascade"
                            :option="{ placeholder: '请选择父级分类（可为空）', clearable: true, filterable: true, width: 250, props: { checkStrictly: true }, closeOnSelect: true }"
                            @finish="handleEditCateParentCascadeChange"
                        />
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">分类名称</div>
                    <div class="form-control">
                        <wcinput
                            :value="editCateForm.name"
                            :option="{ placeholder: '请输入分类名称', type: 'input', clearable: true, width: '250px', ischange: true }"
                            @finish="handleEditCateNameInputChange"
                        />
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">排序</div>
                    <div class="form-control">
                        <wcinput
                            :value="editCateForm.sort"
                            :option="{ placeholder: '请输入排序值', type: 'input', clearable: true, width: '250px', ischange: true }"
                            @finish="handleEditCateSortInputChange"
                        />
                    </div>
                </div>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <wcbutton :option="{ title: '取消', type: 'del' }" @finish="closeEditCateDialog" />
                    <wcbutton :option="{ title: '提交', type: 'primary' }" @finish="submitEditCateName" />
                </div>
            </template>
        </el-dialog>

        <!-- 编辑图片名称弹窗 -->
        <el-dialog v-model="editPhotoDialogVisible" title="编辑图片名称" width="420px" :close-on-click-modal="false" append-to-body>
            <div class="add-cate-form">
                <div class="form-item">
                    <div class="form-label">图片名称</div>
                    <div class="form-control">
                        <wcinput
                            :value="editPhotoForm.name"
                            :option="{ placeholder: '请输入图片名称', type: 'input', clearable: true, width: '250px', ischange: true }"
                            @finish="handleEditPhotoInputChange"
                        />
                    </div>
                </div>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <wcbutton :option="{ title: '取消', type: 'del' }" @finish="closeEditPhotoDialog" />
                    <wcbutton :option="{ title: '提交', type: 'primary' }" @finish="submitEditPhoto" />
                </div>
            </template>
        </el-dialog>

</template>

<script>
import INTERFACE_MODEL_BASE from '@/Interface/index';
import INTERFACE_SYSTEM_PHOTO from '@/Interface/systemphoto.js';
import INTERFACE_SHOP_PHOTO from '@/Interface/shopphoto.js';

/** 全局多图上传 input 当前触发的组件实例 **/
var ttlFilesmoreActiveVm=null;

export default {
  props: {
        isshow: { //是否显示
            type: Boolean,
            default: true,
        },
        issingle: { //false-单选 true-多选
            type: Boolean,
            default: false,
        },
        dialogTitle: {
            type: String,
            default: '',
        },
        phototype: {
            type: String,
            default: 'shop', // shop-商户图集 system-系统图集
        },
        embedded: {
            type: Boolean,
            default: false,
        },
        selectable: {
            type: Boolean,
            default: true,
        },
        returnSize: {
            type: String,
            default: 'middle', // base→url_base，large→url_large，middle/默认/其它→url
        },
  },
  emits: ['update:isshow', 'finish'],
  data() {
      return {
          //上传对象
          fileloading:false,
          fileobj:'',
          templist:[],
          thumblist:[],
          uploadDialogLoading:false,
          uploadDialogLoadingText:'正在处理，请稍等...',
          //分类信息
          categorylist:[],
          categorycascade:[],
          addCateDialogVisible:false,
          addCateLoading:false,
          editCateDialogVisible:false,
          editCateLoading:false,
          editCateForm:{
              id:'',
              parentPath:[''],
              parentid:'',
              levelid:0,
              name:'',
              sort:'',
          },
          editPhotoDialogVisible:false,
          editPhotoLoading:false,
          editPhotoForm:{
              id:'',
              name:'',
          },
          addCateForm:{
              id:'',
              parentPath:[''],
              parentid:'',
              levelid:0,
              name:'',
              sort:'',
          },
          // 图集搜索/分页参数
          searchForm: {
              cateid: '',   // 当前分类 id
              name:'',      // 图片名称关键字
              page:1,       // 当前页（接口参数 p）
              rollpage:21,  // 每页条数（接口参数 rollpage）
              rows:0,       // 总条数（用于分页展示）
          },
          photos:[], //图集信息
          selectphotos:[], //选中的图集信息
          /** 有子节点的分类 id（字符串）为 true 时表示折叠，不展示子级 */
          collapsedCateMap: {},
      }
  },
  mounted() {
      var _this=this;
      if(window.__ttlFilesmoreChangeBound) return;
      window.__ttlFilesmoreChangeBound=true;
      var obj=document.getElementById('TTLFilesmore');
      if(!obj) return;
      obj.addEventListener('change', function(e) {
          if(!ttlFilesmoreActiveVm) return;
          var vm=ttlFilesmoreActiveVm;
          ttlFilesmoreActiveVm=null;
          var input=e.target || e.srcElement;
          if(!input || !input.files || input.files.length===0) return;
          var filelist=[];
          for(var i=0;i<input.files.length;i++) filelist.push(input.files[i]);
          input.value='';
          vm.handleSelectedUploadFiles(filelist);
      });
  },
  computed: {
        currentDialogTitle() {
            if(this.dialogTitle) return this.dialogTitle;
            return this.phototype==='system' ? '系统图集' : '商户图集';
        },
        isSystemPhoto() {
            return this.phototype==='system';
        },
        mainDialogVisible: {
            get() {
                return this.isshow;
            },
            set(val) {
                this.$emit('update:isshow', val);
            },
        },
        // 递归展开分类，兼容 tree/flat 两种结构（受 collapsedCateMap 折叠状态影响）
        categoryDisplayList() {
            const list = Array.isArray(this.categorylist) ? this.categorylist : [];
            if (list.length === 0) return [];
            const hasNestedChildren = list.some((item) => this.getNodeChildren(item).length > 0);
            const tree = hasNestedChildren ? list : this.buildTreeFromFlat(list);
            const result = [];
            this.walkCategoryTree(tree, 0, result);
            return result;
        },
  },
  watch: {
        isshow: {
            immediate: true,
            handler(val) {
                if (val || this.embedded) {
                    this.loadDialogCategoryAndPhotoData();
                } else {
                    this.collapsedCateMap = {};
                }
            },
        },
  },
  methods: {
        /** 拉分类、级联与当前图片列表：仅在弹窗打开、增/改/删分类后调用，不在切换选中分类时调用 */
        async loadDialogCategoryAndPhotoData() {
            await Promise.all([
                this.getCategoryList(),
                this.getCategoryCascadeList(),
            ]);
            await this.getPhotoList();
        },

        //获取分类信息列表
        async getCategoryList() {
            const res = this.isSystemPhoto
                ? await INTERFACE_SYSTEM_PHOTO.GET_SYSTEM_PHOTO_CATE_LIST()
                : await INTERFACE_SHOP_PHOTO.GET_SHOP_PHOTO_CATE_LIST();
            this.categorylist = (res && res.data) ? res.data : [];
        },

        async getCategoryCascadeList() {
            const res = this.isSystemPhoto
                ? await INTERFACE_SYSTEM_PHOTO.GET_SYSTEM_PHOTO_CATE_LIST_FOR_CASCADE()
                : await INTERFACE_SHOP_PHOTO.GET_SHOP_PHOTO_CATE_LIST_FOR_CASCADE();
            this.categorycascade = (res && res.data) ? res.data : [];
        },

        async getPhotoList() {
            const params={
                cateid:this.searchForm.cateid || '',
                name:this.searchForm.name || '',
                p:this.searchForm.page || 1,
                rollpage:this.searchForm.rollpage || 21,
            };
            const res=this.isSystemPhoto
                ? await INTERFACE_SYSTEM_PHOTO.GET_SYSTEM_PHOTO_LIST(params)
                : await INTERFACE_SHOP_PHOTO.GET_SHOP_PHOTO_LIST(params);
            if(res && res.status>0) return;
            this.photos=(res && res.data && Array.isArray(res.data.list)) ? res.data.list : [];
            this.searchForm.rows=(res && res.data && Number(res.data.count)>=0) ? Number(res.data.count) : 0;
        },

        handleSearch() {
            // 搜索时重置到第一页，避免停留在旧页码导致空列表
            this.searchForm.page=1;
            this.getPhotoList();
        },

        handleConfirmSelection() {
            if(!Array.isArray(this.selectphotos) || this.selectphotos.length===0) {
                this.$notice({ title: '提示', message: '请先选择图片', type: 'warning' });
                return;
            }
            const urls = this.selectphotos
                .map((item) => this.getPhotoReturnUrl(item))
                .filter(Boolean);
            if(urls.length===0) {
                this.$notice({ title: '提示', message: '请先选择图片', type: 'warning' });
                return;
            }
            this.$emit('finish', {type:'submit',data:urls});
            this.selectphotos=[];
        },

        /** 按 returnSize 取对应尺寸链接：base→url_base，large→url_large，其它→url **/
        getPhotoReturnUrl(item) {
            if(!item) return '';
            if(typeof item === 'string') return item;
            const size = String(this.returnSize || '').toLowerCase().trim();
            if(size === 'base') return item.url_base || item.url || '';
            if(size === 'large') return item.url_large || item.url || '';
            return item.url || '';
        },

        getPhotoSelectKey(item) {
            if(!item) return '';
            if(typeof item === 'string') return item;
            return item.url || String(item.id || '');
        },

        handleMainDialogClose() {
            if(ttlFilesmoreActiveVm===this) ttlFilesmoreActiveVm=null;
            this.toggleUploadLoading(false);
            this.selectphotos=[];
            this.collapsedCateMap = {};
            this.$emit('finish', {type:'cannel'});
        },

        handleResetSelection() {
            this.$confirm.confirm(
                '确认重置已选图片吗？',
                '重置提示',
                { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }
            ).then(() => {
                this.selectphotos = [];
            }).catch(() => {});
        },

        handleSearchNameChange(payload) {
            this.searchForm.name = payload && payload.value !== undefined ? payload.value : '';
            if(payload && payload.type==='keydown') {
                this.handleSearch();
            }
        },

        handleCateSelect(item) {
            this.searchForm.cateid = item && item.id > 0 ? item.id : '';
            this.searchForm.ischange = true;
            this.$nextTick(() => {
                this.getPhotoList();
            });
        },

        onCateCaretClick(item) {
            if (!item || !item._hasChildren) return;
            this.toggleCateExpand(item);
        },

        toggleCateExpand(item) {
            if (!item || !item._hasChildren) return;
            const id = String(item.id);
            const next = { ...this.collapsedCateMap };
            if (next[id]) delete next[id];
            else next[id] = true;
            this.collapsedCateMap = next;
        },

        toggleSelectPhoto(item) {
            if(!this.selectable) return;
            if(!item) return;
            const key=this.getPhotoSelectKey(item);
            if(!key) return;
            const index=this.selectphotos.findIndex((row) => this.getPhotoSelectKey(row)===key);
            if(index>-1) {
                this.selectphotos.splice(index,1);
            }else{
                if(this.issingle===false && this.selectphotos.length>=1) {
                    this.$notice({ title: '提示', message: '最多只能选择一张图片', type: 'warning' });
                    return;
                }
                this.selectphotos.push(item);
            }
        },

        /** 是否选中指定图片 **/
        isPhotoSelected(item) {
            const key=this.getPhotoSelectKey(item);
            if(!key) return false;
            return this.selectphotos.some((row) => this.getPhotoSelectKey(row)===key);
        },

        /** 显示选中图片序号 **/
        showSelectSort(item) {
            const key=this.getPhotoSelectKey(item);
            if(!key) return -1;
            const index=this.selectphotos.findIndex((row) => this.getPhotoSelectKey(row)===key);
            return index>-1 ? index+1 : 0;
        },

        openEditPhotoDialog(item) {
            if(!item || !item.id) return;
            this.editPhotoForm.id=item.id;
            this.editPhotoForm.name=item.name || '';
            this.editPhotoDialogVisible=true;
        },

        closeEditPhotoDialog() {
            this.editPhotoDialogVisible=false;
        },

        handleEditPhotoInputChange(payload) {
            this.editPhotoForm.name = payload && payload.value !== undefined ? payload.value : '';
        },

        async submitEditPhoto() {
            if(this.editPhotoLoading) return;
            if(!this.editPhotoForm.id) return;
            if(!this.editPhotoForm.name || String(this.editPhotoForm.name).trim()==='') {
                this.$notice({ title: '提示', message: '请填写图片名称', type: 'warning' });
                return;
            }
            try{
                this.editPhotoLoading=true;
                const params={
                    id:this.editPhotoForm.id,
                    name:String(this.editPhotoForm.name).trim(),
                };

                const res=this.isSystemPhoto
                    ? await INTERFACE_SYSTEM_PHOTO.CHANGE_SYSTEM_PHOTO_NAME(params)
                    : await INTERFACE_SHOP_PHOTO.CHANGE_SHOP_PHOTO_NAME(params);
                if(res && res.status>0) return;
                this.$notice({ title: '成功', message: '修改图片名称成功', type: 'success' });
                this.editPhotoDialogVisible=false;
                await this.getPhotoList();
            }finally{
                this.editPhotoLoading=false;
            }
        },

        async handleDeletePhoto(item) {
            if(!item || !item.id) return;
            const rawName=item.name && String(item.name).trim() ? String(item.name).trim() : '';
            const msg=rawName
                ? `确定要删除图片「${rawName}」吗？删除后不可恢复！`
                : '确定要删除该图片吗？删除后不可恢复！';
            this.$confirm.confirm(
                msg,
                '删除提示',
                { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }
            ).then(async () => {

                const res=this.isSystemPhoto
                    ? await INTERFACE_SYSTEM_PHOTO.DEL_SYSTEM_PHOTO({ id:item.id })
                    : await INTERFACE_SHOP_PHOTO.DEL_SHOP_PHOTO({ id:item.id });
                if(res && res.status>0) return;
                this.$notice({ title: '成功', message: '删除图片成功', type: 'success' });
                this.selectphotos=this.selectphotos.filter((row) => this.getPhotoSelectKey(row) !== item.url);
                await this.getPhotoList();
            }).catch(() => {});
        },

        openAddCateDialog() {
            this.resetAddCateForm();
            this.addCateDialogVisible=true;
        },

        openEditCateDialog(item) {
            if(!item || !item.id) return;
            this.editCateForm.id=item.id;
            const parentid=item.parentid !== undefined && item.parentid !== null ? item.parentid : '';
            const path=this.findCascadePathById(parentid, this.categorycascade);
            this.editCateForm.parentPath=path.length ? path : [''];
            this.editCateForm.parentid=parentid > 0 ? parentid : '';
            this.editCateForm.levelid=item.levelid !== undefined && item.levelid !== null ? Number(item.levelid) : 0;
            this.editCateForm.name=item.name || '';
            this.editCateForm.sort=item.sort !== undefined && item.sort !== null ? item.sort : '';
            this.editCateDialogVisible=true;
        },

        closeEditCateDialog() {
            this.editCateDialogVisible=false;
        },

        handleEditCateNameInputChange(payload) {
            this.editCateForm.name=payload && payload.value !== undefined ? payload.value : '';
        },
        handleEditCateSortInputChange(payload) {
            this.editCateForm.sort=payload && payload.value !== undefined ? payload.value : '';
        },
        applyParentPath(form, path) {
            const next=Array.isArray(path) ? path : [];
            form.parentPath=next;
            const lastValue=next.length > 0 ? next[next.length-1] : '';
            if(next.length===0 || lastValue === '' || lastValue === null) {
                form.parentid='';
                form.levelid=0;
                return;
            }
            const parentid=Number(lastValue);
            form.parentid=Number.isNaN(parentid) ? '' : parentid;
            const parentNode=this.categoryDisplayList.find((item)=>String(item.id)===String(parentid));
            const parentLevel=parentNode ? Number(parentNode._level || parentNode.levelid || 0) : 0;
            form.levelid=parentLevel+1;
        },

        handleEditCateParentCascadeChange(val) {
            const path = val && Array.isArray(val.value) ? val.value : (Array.isArray(val) ? val : []);
            this.applyParentPath(this.editCateForm, path);
        },

        async submitEditCateName() {
            if(this.editCateLoading) return;
            const name=String(this.editCateForm.name || '').trim();
            const currentId=Number(this.editCateForm.id || 0);
            const parentId=Number(this.editCateForm.parentid || 0);
            if(!name) {
                this.$notice({ title: '提示', message: '请填写分类名称', type: 'warning' });
                return;
            }
            if(this.editCateForm.sort === '' || this.editCateForm.sort === null) {
                this.$notice({ title: '提示', message: '请填写排序', type: 'warning' });
                return;
            }
            if(currentId > 0 && parentId > 0 && currentId === parentId) {
                this.$notice({ title: '提示', message: '父级分类不能选择当前分类', type: 'warning' });
                return;
            }
            try{
                this.editCateLoading=true;
                const params={
                    id: this.editCateForm.id,
                    parentid:this.editCateForm.parentid > 0 ? this.editCateForm.parentid : 0,
                    levelid:this.editCateForm.levelid,
                    name: name,
                    sort: this.editCateForm.sort,
                    root_name:'',
                };
                const res=this.isSystemPhoto
                    ? await INTERFACE_SYSTEM_PHOTO.ADD_SYSTEM_PHOTO_CATE(params)
                    : await INTERFACE_SHOP_PHOTO.ADD_SHOP_PHOTO_CATE(params);
                if(res && res.status>0) return;
                this.$notice({ title: '成功', message: '修改分类成功', type: 'success' });
                this.editCateDialogVisible=false;
                await this.loadDialogCategoryAndPhotoData();
            }finally{
                this.editCateLoading=false;
            }
        },

        closeAddCateDialog() {
            this.addCateDialogVisible=false;
        },

        resetAddCateForm() {
            this.addCateForm={
                id:'',
                parentPath:[''],
                parentid:'',
                levelid:0,
                name:'',
                sort:'',
            };
        },

        handleParentCascadeChange(val) {
            const path = val && Array.isArray(val.value) ? val.value : (Array.isArray(val) ? val : []);
            this.applyParentPath(this.addCateForm, path);
        },

        handleAddCateInputChange(field, payload) {
            const value=payload && payload.value !== undefined ? payload.value : '';
            this.addCateForm[field]=value;
        },

        findCascadePathById(targetId, list, trail=[]) {
            if(!Array.isArray(list) || list.length===0) return [];
            for(let i=0;i<list.length;i+=1) {
                const node=list[i];
                const currentTrail=[...trail, node.value];
                if(String(node.value)===String(targetId)) return currentTrail;
                const children=Array.isArray(node.children) ? node.children : [];
                if(children.length>0) {
                    const result=this.findCascadePathById(targetId, children, currentTrail);
                    if(result.length>0) return result;
                }
            }
            return [];
        },

        async submitAddCategory() {
            if(this.addCateLoading) return;
            if(!this.addCateForm.name || String(this.addCateForm.name).trim()==='') {
                this.$notice({ title: '提示', message: '请填写分类名称', type: 'warning' });
                return;
            }
            if(this.addCateForm.sort === '' || this.addCateForm.sort === null) {
                this.$notice({ title: '提示', message: '请填写排序', type: 'warning' });
                return;
            }
            const params={
                id:this.addCateForm.id || '',
                parentid:this.addCateForm.parentid > 0 ? this.addCateForm.parentid : 0,
                levelid:this.addCateForm.levelid,
                name:String(this.addCateForm.name).trim(),
                sort:this.addCateForm.sort,
                root_name:'',
            };
            try{
                this.addCateLoading=true;
                this.isSystemPhoto
                    ? await INTERFACE_SYSTEM_PHOTO.ADD_SYSTEM_PHOTO_CATE(params)
                    : await INTERFACE_SHOP_PHOTO.ADD_SHOP_PHOTO_CATE(params);
                this.$notice({ title: '成功', message: '新增分类成功', type: 'success' });
                this.addCateDialogVisible=false;
                await this.loadDialogCategoryAndPhotoData();
            }finally{
                this.addCateLoading=false;
            }
        },

        async handleDeleteCate(item) {
            if(!item || !item.id) return;
            this.$confirm.confirm(
                '确认删除该分类及其所有子分类吗？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(async () => {
                const ids=this.getDeleteIds(item.id);
                if(ids.length===0) return;

                this.isSystemPhoto
                    ? await INTERFACE_SYSTEM_PHOTO.DEL_SYSTEM_PHOTO_CATE({ ids: ids.join(',') })
                    : await INTERFACE_SHOP_PHOTO.DEL_SHOP_PHOTO_CATE({ ids: ids.join(',') });
                this.$notice({ title: '成功', message: '删除分类成功', type: 'success' });
                await this.loadDialogCategoryAndPhotoData();
            }).catch(() => {});
        },

        getDeleteIds(targetId) {
            const list=Array.isArray(this.categorylist) ? this.categorylist : [];
            if(list.length===0) return [];
            const hasNestedChildren=list.some((item) => this.getNodeChildren(item).length > 0);
            const tree=hasNestedChildren ? list : this.buildTreeFromFlat(list);
            const targetNode=this.findCategoryNodeById(targetId, tree);
            if(!targetNode) return [targetId];
            const ids=[];
            this.collectCategoryIds(targetNode, ids);
            return ids;
        },

        findCategoryNodeById(targetId, nodes) {
            if(!Array.isArray(nodes)) return null;
            for(let i=0;i<nodes.length;i+=1) {
                const node=nodes[i];
                if(String(node.id)===String(targetId)) return node;
                const children=this.getNodeChildren(node);
                if(children.length>0) {
                    const found=this.findCategoryNodeById(targetId, children);
                    if(found) return found;
                }
            }
            return null;
        },

        collectCategoryIds(node, ids) {
            if(!node || !node.id) return;
            ids.push(node.id);
            const children=this.getNodeChildren(node);
            children.forEach((child) => {
                this.collectCategoryIds(child, ids);
            });
        },

        //上传图片
        uploadimages() {
            this.thumblist=[];
            this.templist=[];
            this.fileloading=false;
            clearInterval(this.fileobj);
            var obj=document.getElementById('TTLFilesmore');
            if(!obj) {
                this.$notice({ title:'提示', message:'上传控件未就绪，请刷新页面后重试', type:'warning' });
                return;
            }
            ttlFilesmoreActiveVm=this;
            obj.click();
        },

        /** 选择文件回调 **/
        handleSelectedUploadFiles(filelist) {
            var _this=this;
            this.prepareUploadFiles(filelist).catch(function() {
                _this.toggleUploadLoading(false);
                _this.$notice({ title:'提示', message:'文件处理失败，请重试', type:'warning' });
            });
        },

        /** 获取文件大小（KB） **/
        getFileSizeKb(size) {
            return (size / 1024).toFixed(0);
        },

        /** 选择文件后预处理：大文件询问是否压缩 **/
        async prepareUploadFiles(filelist) {
            if(!filelist || filelist.length===0) return;
            var maxSize=1024 * 1024 * 2.5;
            var files=[];
            for(var i=0;i<filelist.length;i++) {
                if(filelist[i] && filelist[i].size) files.push(filelist[i]);
            }
            if(files.length===0) return;

            for(var j=0;j<files.length;j++) {
                var file=files[j];
                if(file.size <= maxSize) {
                    this.templist.push(file);
                    continue;
                }
                var sizeKb=this.getFileSizeKb(file.size);
                try {
                    await this.$confirm.confirm(
                        `文件「${file.name}」大小为 ${sizeKb}KB，已超过 2.5MB，需要压缩至约 2.5MB 后上传，是否进行压缩？`,
                        '压缩提示',
                        { confirmButtonText: '压缩上传', cancelButtonText: '取消', type: 'warning', zIndex: 10001, appendTo: 'body' }
                    );
                    await this.$nextTick();
                    this.toggleUploadLoading(true, '正在压缩图片，请稍等...');
                    var compressed=await this.compressImageFile(file);
                    this.toggleUploadLoading(false);
                    this.templist.push(compressed);
                } catch (err) {
                    this.toggleUploadLoading(false);
                    if(err==='cancel' || err==='close') continue;
                    if(err && err.message==='not image') {
                        this.$notice({ title: '提示', message: '该文件不是图片，无法压缩，已跳过', type: 'warning' });
                        continue;
                    }
                    this.$notice({ title: '提示', message: '文件压缩失败，已跳过该文件', type: 'warning' });
                }
            }
            if(this.templist.length===0) return;
            this.startUploadQueue();
        },

        /** 开始上传队列 **/
        startUploadQueue() {
            var _this=this;
            this.toggleUploadLoading(true, '正在上传文件，请稍等...');
            clearInterval(this.fileobj);
            this.fileobj=setInterval(function() {
                _this.uploadfile();
            },100);
        },

        /** 压缩图片文件 **/
        compressImageFile(file) {
            return new Promise((resolve, reject) => {
                if(!file.type || file.type.indexOf('image/')!==0) {
                    reject(new Error('not image'));
                    return;
                }
                var maxSize=2500 * 1024;
                var reader=new FileReader();
                reader.onload=(e)=> {
                    var img=new Image();
                    img.onload=()=> {
                        var canvas=document.createElement('canvas');
                        var maxWidth=1920;
                        var maxHeight=1920;
                        var width=img.width;
                        var height=img.height;
                        if(width>maxWidth || height>maxHeight) {
                            if(width / height > maxWidth / maxHeight) {
                                height=Math.round(height * maxWidth / width);
                                width=maxWidth;
                            } else {
                                width=Math.round(width * maxHeight / height);
                                height=maxHeight;
                            }
                        }
                        canvas.width=width;
                        canvas.height=height;
                        var ctx=canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0, width, height);
                        var quality=0.8;
                        var tryCompress=()=> {
                            canvas.toBlob((blob)=> {
                                if(!blob) {
                                    reject(new Error('compress fail'));
                                    return;
                                }
                                if(blob.size > maxSize && quality>0.3) {
                                    quality=Math.round((quality - 0.1) * 10) / 10;
                                    tryCompress();
                                    return;
                                }
                                var newName=file.name.replace(/\.[^.]+$/, '') + '.jpg';
                                resolve(new File([blob], newName, { type: blob.type || 'image/jpeg' }));
                            }, 'image/jpeg', quality);
                        };
                        tryCompress();
                    };
                    img.onerror=()=> reject(new Error('load fail'));
                    img.src=e.target.result;
                };
                reader.onerror=()=> reject(new Error('read fail'));
                reader.readAsDataURL(file);
            });
        },

        /** 图集弹窗上传 loading **/
        toggleUploadLoading(isOpen, title) {
            this.uploadDialogLoading=!!isOpen;
            if(isOpen && title) this.uploadDialogLoadingText=title;
            if(!isOpen) this.uploadDialogLoadingText='正在处理，请稍等...';
        },


        /** 执行上传文件操作 **/
        async uploadfile() {
          //文件上传结束
          if(this.templist.length==0) {
              this.fileloading=false;
              clearInterval(this.fileobj); //关闭定时任务
              //上传图片信息到图集
              const res=this.isSystemPhoto
                  ? await INTERFACE_SYSTEM_PHOTO.ADD_SYSTEM_PHOTO({thumbs:this.thumblist.join(','),cateid:this.searchForm.cateid})
                  : await INTERFACE_SHOP_PHOTO.ADD_SHOP_PHOTO({thumbs:this.thumblist.join(','),cateid:this.searchForm.cateid});
              this.toggleUploadLoading(false);
              if(res.status > 0) return false;
              this.getPhotoList(); //刷新列表信息
              return false;
          }

          if(this.fileloading) return false; //正在执行上传操作
          this.fileloading=true; //上锁，标记操作正在执行

          var file=this.templist[0]; //提取待上传的文件
          if(!file || !file.size) {
              this.templist.splice(0,1);
              this.fileloading=false;
              return false;
          }
          INTERFACE_MODEL_BASE.UPLOAD_FILES({imageType:'normal',File:file}).then((res) => {
                this.templist.splice(0,1);  //删除已上传的文件数据
                this.fileloading=false;  //开关释放                 
                if(res.status > 0) return false;
                var url=res.data && res.data.url ? res.data.url : '';
                if(url && url.indexOf('http')!==0) url=(process.env.VUE_APP_IMAGE_ADDRESS || '')+url;
                this.thumblist.push(url);
          }).catch(()=> {
                this.templist.splice(0,1);
                this.fileloading=false;
          });
      },



        //////////////////////////////////////////////////////////////////////////////
        //功能操作

        getNodeChildren(node) {
            if (!node || typeof node !== 'object') return [];
            const keys = ['children', 'child', 'sub', 'list'];
            for (let i = 0; i < keys.length; i += 1) {
                const cur = node[keys[i]];
                if (Array.isArray(cur) && cur.length > 0) return cur;
            }
            return [];
        },

        buildTreeFromFlat(list) {
            const map = new Map();
            const roots = [];
            list.forEach((item) => {
                map.set(item.id, { ...item, children: [] });
            });
            list.forEach((item) => {
                const cur = map.get(item.id);
                const pid = Number(item.parentid || 0);
                if (pid > 0 && map.has(pid)) {
                    map.get(pid).children.push(cur);
                } else {
                    roots.push(cur);
                }
            });
            return roots;
        },

        walkCategoryTree(nodes, level, result) {
            if (!Array.isArray(nodes)) return;
            nodes.forEach((item) => {
                const children = this.getNodeChildren(item);
                const hasChildren = children.length > 0;
                result.push({ ...item, _level: level, _hasChildren: hasChildren });
                const collapsed = hasChildren && this.collapsedCateMap[String(item.id)];
                if (hasChildren && !collapsed) {
                    this.walkCategoryTree(children, level + 1, result);
                }
            });
        },

  }

}
</script>
<style scoped>
:deep(.ttl-system-photos-wrap-dialog.el-dialog) {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    max-height: 92vh;
}
.ttl-system-photos-wrap-dialog.is-embedded {
    display: block;
    width: 100%;
    min-height: 620px;
}
.ttl-system-photos-wrap-dialog.is-embedded .TTL-system-photos-box {
    min-height: calc(100vh - 180px);
}
:deep(.ttl-system-photos-wrap-dialog .el-dialog__body) {
    flex: 1;
    padding: 8px 16px 16px;
    max-height: calc(92vh - 110px);
    overflow: auto;
    box-sizing: border-box;
}
.TTL-system-photos-box {
    display:inline-flex;
    justify-content: space-between;
    padding-top:10px;
    width:calc(100% - 10px);
    height:100%;
    min-height: 400px;
    position: relative;
}
.TTL-cate-box {
    display:inline-block;
    width:250px;
    height:calc(100% - 2px);
    min-height: 500px;
    border:1px solid #bbb9b9;
    border-radius: 10px;
}
.TTL-add-cate {
    display:inline-flex;
    justify-content: center;
    align-items: center;
    width:100%;
    height:50px;
    font-size:13px;
    color:#333;
    border-bottom:1px solid #bbb9b9;
    cursor: pointer;
}
.TTL-cate-content {
    display:inline-block;
    padding:0 10px;
    width:calc(100% - 20px);
    height:calc(100% - 50px);
    overflow-y: auto;
    scrollbar-gutter: stable;
}
.TTL-cate-content::-webkit-scrollbar {
    width:0;
}
.cate-box {
    display:inline-block;
    padding:0 0 0 10px;
    width:calc(100% - 10px);
    font-size:0;
}
.cate-item {
    position:relative;
    display:inline-block;
    width:100%;
    font-size:0;
}
.cate-name-box {
    display:inline-flex;
    justify-content: space-between;
    align-items: center;
    padding:20px 0;
    width:100%;
    font-size:13px;
    color:#333;
    contain: layout;
}
.cate-name-box .title {
    display: inline-flex;
    align-items: center;
    flex:1;
    min-width:0;
    box-sizing:border-box;
    padding-right:10px;
    cursor: pointer;
}
.cate-name-box .title.title-with-caret {
    gap: 6px;
}
.cate-name-box .title .cate-title-text {
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.cate-name-box .title.title-with-caret .cate-title-caret-wrap {
    flex-shrink: 0;
}
.cate-name-box .cate-title-caret-wrap {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    min-height: 22px;
    margin-right: 2px;
    cursor: pointer;
    user-select: none;
}
.cate-name-box .cate-title-caret {
    display: inline-block;
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 5px solid #999;
    border-bottom: 0;
    vertical-align: middle;
    transition: transform 0.15s ease;
    transform-origin: 50% 40%;
}
.cate-name-box .cate-title-caret.is-collapsed {
    transform: rotate(-90deg);
}
.cate-name-box .icon-box {
    display:inline-flex;
    gap:10px;
    min-width: 40px;
    flex-shrink: 0;
    justify-content: flex-end;
    align-items: center;
}
.cate-name-box .icon-box.is-empty {
    visibility: hidden;
    pointer-events: none;
}
.cate-name-box .icon-box .icon {
    width:15px;
    height:15px;
    background-repeat: no-repeat;
    background-position: center;
    background-size:100%;
    cursor: pointer;
}
.up {
    background-image:url('@/assets/icon/icloud.png');
}
.del {
    background-image:url('@/assets/icon/del-black.png');
}
.edit {
    background-image:url('@/assets/icon/edit-black.png');
}

.TTL-photo-box {
    display:inline-block;
    width:calc(100% - 252px - 20px);
    height:100%;
    overflow-y: scroll;
}
.TTL-photo-box::-webkit-scrollbar {
    width:0;
}
.photo-header-box {
    display: inline-block;
    width:100%;
    position:sticky;
    top:0;
    background-color: #ffffff;
    z-index: 50;
    padding:15px 0 0 0;
}
.header-notice {
    font-size:12px;
    color:#999;
}
.add-cate-form {
    display:block;
    width:100%;
}
.form-item {
    display:flex;
    align-items:center;
    margin-bottom:16px;
}
.form-item:last-child {
    margin-bottom:0;
}
.form-label {
    flex-shrink:0;
    width:72px;
    margin-right:10px;
    font-size:13px;
    color:#333;
}
.form-control {
    flex:1;
}
.dialog-footer {
    display:inline-flex;
    justify-content:flex-end;
    column-gap:10px;
    width:100%;
}

.photo-content-box {
    position:relative;
    display:grid;
    grid-template-columns: repeat(7, 1fr);
    gap:10px;
    width:100%;
    /* height:100%; */
}
.photo-items {
    position:relative;
    display:inline-block;
    width:110px;
    text-align: center;
    font-size:0;
    border-radius:15px;
    padding-bottom:15px;
    cursor: pointer;
}
.photo-items-active .pic {
    box-shadow: 0 0 0 2px #409eff inset;
}
.photo-items .pic-box {
    display:inline-flex;
    justify-content: center;
    align-items: center;
    width:100%;
    height:110px;
    border-radius: 15px;
    background-color: #f5f5f5;
    overflow: hidden;
}
.photo-items .pic {
    /* display:inline-block;
    width:100%;
    height:130px;
    border-radius: 15px; */
    max-width: 100%;
    max-height: 100%;
}
.pic-name-box {
    display: inline-flex;
    justify-content:space-between;
    align-items: center;
    width:100%;
    font-size:0;
}
.pic-name-box .name {
    display: inline-block;
    width: calc(100% - 45px);
    min-width: 0;
    overflow: hidden; 
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size:12px;
    color:#333;
    text-align: left;
}
.pic-btn-box {
    display:inline-flex;
    column-gap: 5px;
    width:40px;
    font-size:0;
}
.pic-btn-box .icon {
    width:15px;
    height:15px;
    background-repeat: no-repeat;
    background-position: center;
    background-size:100%;
    cursor: pointer;
}
.empty-data {
    display:flex;
    justify-content:center;
    align-items:center;
    grid-column: 1 / -1;
    width:100%;
    min-height:260px;
    text-align: center;
}
.photo-check,.photo-check-sort {
    position:absolute;
    width:20px;
    height:20px;
    top:0;
    right:0;
    background-image:url('@/assets/icon/right-blue.png');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10;
}
.photo-check-sort {
    background-image: none;
    border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size:12px;
    line-height:12px;
    color:#ffffff;
    background-color: #666eeb;
}

.TTL-page-box {
    position:relative;
    display: block;
    width:100%;
    margin-top:60px;
}
</style>